// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__dHzII","box":"WorkspacesBox_box__Lx3Jw","node":"WorkspacesBox_node__3G0ew"};